/**
 * RUM-protected APIM endpoints.
 *
 * Mirrors legacy `environment.raptorApimAuthentication.endpoints` consumed by
 * `RumInterceptor` (`raptor-shell-ui/.../rum.interceptor.ts`). Requests whose
 * URL starts with one of these base paths require a `Raptor-Authorization`
 * header carrying a RUM token (`getRumToken(clientId, scopes)`) IN ADDITION to
 * the Azure AD bearer token. Without it the APIM gateway returns 401.
 *
 * Scopes are the RUM token scope string (e.g. 'Portal'), NOT Azure scopes.
 */
const APIM = import.meta.env.VITE_RAPTOR_APIM_BASE_URL;

interface RaptorAuthEndpoint {
  readonly basePath: string;
  readonly scopes: string;
}

const RAPTOR_AUTH_ENDPOINTS: readonly RaptorAuthEndpoint[] = [
  { basePath: `${APIM}/portalapps/api`, scopes: 'Portal' },
  { basePath: `${APIM}/portaladmin/api`, scopes: 'Portal' },
  { basePath: `${APIM}/role-scr-mgmt/api`, scopes: 'Portal' },
  { basePath: `${APIM}/incidentstatus`, scopes: 'Portal' },
  { basePath: `${APIM}/myteams/api`, scopes: 'MyTeams' },
];

/**
 * Returns the RUM-token scope for an endpoint that needs a
 * `Raptor-Authorization` header, or `null` when the URL is not RUM-protected.
 */
export function raptorAuthForUrl(url: string): { scopes: string } | null {
  const match = RAPTOR_AUTH_ENDPOINTS.find((endpoint) => url.startsWith(endpoint.basePath));
  return match ? { scopes: match.scopes } : null;
}
